import styled from 'styled-components';
import ComingSoonIcon from '@src/icons/coming-soon-icon.svg';
import { EllipsisTooltip } from '@components/common';

export const ContentPanelWrapper = styled.div`
  height: 100%;
  width: 100%;
  margin-top: 20px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  background-color: #fff;

  .ant-tabs-nav-wrap {
    left: 135px;
  }

  .ant-select-arrow {
    opacity: 0.5;
  }

  .ant-select-selection-item {
    font-size: 18px;
    font-weight: 500;
  }
`;

export const TabContentWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  flex: 1;
`;

export const TableWrapper = styled.div`
  min-height: 500px;
  height: 100%;
  position: relative;
`;

export const HeaderCellWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  .ant-input-suffix {
    margin-left: 150px;
  }
`;

export const DataTableWrapper = styled.div`
  height: calc(100% - 55px);
`;

export const StyledLinkCell = styled.div`
  display: flex;
  width: 100%;
`;

export const StyledLinkButton = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  color: #4080e2;
  cursor: pointer;

  &:hover {
    color: #0945a2;
  }
`;

export const StyledFeedTitle = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
`;

export const SelectWrapper = styled.div`
  display: flex;
  position: absolute;
  margin-top: 5px;
`;

export const IconWrapper = styled.div`
  height: 100%;
  position: relative;
  background-color: #e9edf0;
  margin: 45px -20px -10px;
`;

export const StyledComingSoonIcon = styled(ComingSoonIcon)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 500px;
`;

export const StyledCell = styled.div`
  height: 100%;
  width: 100%;
  font-size: 1rem;
  display: flex;
  justify-content: right;
  align-items: center;
`;

export const StyledEllipsisTooltip = styled(EllipsisTooltip)`
  font-weight: 500;
  color: ${(props) => (props.selected ? '#0046ff' : 'unset')};
  align-self: center;
`;
